import { render, staticRenderFns } from "./WifiSwitch.vue?vue&type=template&id=ea6b6272&scoped=true&"
import script from "./WifiSwitch.vue?vue&type=script&lang=js&"
export * from "./WifiSwitch.vue?vue&type=script&lang=js&"
import style0 from "./WifiSwitch.vue?vue&type=style&index=0&id=ea6b6272&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea6b6272",
  null
  
)

export default component.exports